import { Flex } from "@chakra-ui/react";
import React from "react";
import CompanySidebar from "../../Components/CompanySidebar";
import CompanyHomeDash from "./CompanyHomeDash/CompanyHomeDash";

const CompanyDash = () => {

  return (
    <Flex>
    <CompanySidebar />
    <CompanyHomeDash />
  </Flex>
  );
};

export default CompanyDash;
